
















import Vue from 'vue'
import { Component, Mixins, Prop } from 'vue-property-decorator'

// @ts-ignore
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import { Modals } from '@/mixins/modals'
import { ModalStore, IModalParams } from '~/store/modal'

@Component
export default class ShareLinkModal extends Mixins(Modals) {
    @Prop({ type: String }) link!: string
    @Prop({ type: String }) title: string

    isCopied = false

    doCopy() {
        // @ts-ignore
        this.$copyText(this.link)
        this.isCopied = true
    }
}
